const mandDoclistItemText = {
  expiration: 'dias restantes'
};

export default mandDoclistItemText;
